import type { EditorSDK } from '@wix/platform-editor-sdk';

import { APP_TOKEN } from '../constants';

export type Action<T> = () => T;

const runAndWaitForApproval = async <T>(editorSDK: EditorSDK, action: Action<T>): Promise<ReturnType<Action<T>>> =>
  editorSDK.document.transactions.runAndWaitForApproval(APP_TOKEN, action);

export { runAndWaitForApproval };
